import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <h2>AppsDNA</h2>
          <p>Mobile Application Development</p>
        </div>
        <div className="footer-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Use</a>
          <a href="mailto:team@appdna.ai">team@appdna.ai</a>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 AppsDNA. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;